class RightsCategory {
  constructor(
    description,
    descriptionHash,
    id,
    image,
    subtitle,
    subtitleHash,
    title,
    titleHash
  ) {
    this.description = description;
    this.descriptionHash = descriptionHash;
    this.id = id;
    this.image = image;
    this.subtitle = subtitle;
    this.subtitleHash = subtitleHash;
    this.title = title;
    this.titleHash = titleHash;
  }
}

export default RightsCategory;
